import React from "react";
import "./Loading.Module.css";
const Loading = () => {
  return (
    <>
      <div class="popcorn">
        <svg
          class="mypopcorn animated fadeIn"
          version="1.1"
          id="Capa_1"
          x="0px"
          y="0px"
          viewBox="0 0 354.461 354.461"
        >
          <g id="XMLID_484_" />

          <circle
            id="popcrncirlce"
            class="firstcirle"
            cx="260.426"
            cy="22.695"
            r="22.695"
          />

          <circle
            id="popcrncirlce"
            class="firstcirle"
            cx="163.426"
            cy="-16.695"
            r="22.695"
          />

          <circle
            id="popcrncirlce"
            class="firstcirle"
            cx="65.426"
            cy="22.695"
            r="22.695"
          />

          <path
            id="XMLID_488_"
            style={{ fill: "#FFEB99" }}
            d="M278.375,128.664c-0.05,0-0.099,0.007-0.149,0.008
		c0.092-0.831,0.149-1.673,0.149-2.529c0-12.534-10.161-22.695-22.695-22.695c-0.05,0-0.099,0.007-0.149,0.008
		c0.092-0.831,0.149-1.673,0.149-2.529c0-12.534-10.161-22.695-22.695-22.695c-0.752,0-1.495,0.041-2.228,0.112
		c0.1-0.866,0.165-1.742,0.165-2.634c0-12.099-9.475-21.958-21.406-22.63C208.895,41.1,199.014,31.57,186.88,31.57
		c-12.136,0-22.018,9.533-22.635,21.515c-0.04-0.002-0.08-0.004-0.119-0.006C163.505,41.1,153.624,31.57,141.491,31.57
		c-12.136,0-22.018,9.533-22.635,21.515c-0.468-0.029-0.933-0.071-1.408-0.071c-12.534,0-22.695,10.161-22.695,22.695
		c0,0.887,0.064,1.757,0.162,2.618C83.272,79.295,74.12,89.034,74.12,100.926c0,0.856,0.057,1.698,0.149,2.529
		c-0.05,0-0.099-0.008-0.149-0.008c-12.534,0-22.695,10.161-22.695,22.695c0,0.856,0.057,1.698,0.149,2.529
		c-0.05,0-0.099-0.008-0.149-0.008c-12.534,0-22.695,10.161-22.695,22.695c0,12.534,10.161,22.695,22.695,22.695
		c12.534,0,22.695-10.161,22.695-22.695c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008
		c-0.092,0.831-0.149,1.673-0.149,2.529c0,12.534,10.161,22.695,22.695,22.695s22.695-10.161,22.695-22.695
		c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008c0.05,0,0.099-0.007,0.149-0.008
		c-0.092,0.831-0.149,1.673-0.149,2.529c0,12.534,10.161,22.695,22.695,22.695c12.534,0,22.695-10.161,22.695-22.695
		c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,12.534,10.161,22.695,22.695,22.695c12.534,0,22.695-10.161,22.695-22.695c0-0.856-0.057-1.698-0.149-2.529
		c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,12.534,10.161,22.695,22.695,22.695s22.695-10.161,22.695-22.695c0-0.856-0.057-1.698-0.149-2.529
		c0.05,0,0.099,0.008,0.149,0.008c0.05,0,0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,12.534,10.161,22.695,22.695,22.695c12.534,0,22.695-10.161,22.695-22.695C301.07,138.825,290.909,128.664,278.375,128.664z
		 M185.473,76.889c0.04,0.002,0.08,0.004,0.119,0.006c0.025,0.48,0.048,0.96,0.103,1.432c-0.108,0.009-0.22,0.006-0.328,0.017
		C185.423,77.864,185.447,77.377,185.473,76.889z M140.083,76.889c0.04,0.002,0.08,0.004,0.119,0.006
		c0.025,0.48,0.048,0.96,0.103,1.432c-0.108,0.009-0.22,0.006-0.328,0.017C140.033,77.864,140.057,77.377,140.083,76.889z
		 M96.666,128.672c0.092-0.831,0.149-1.673,0.149-2.529c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008
		c0.05,0,0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529c0,0.856,0.057,1.698,0.149,2.529
		c-0.05,0-0.099-0.008-0.149-0.008C96.765,128.664,96.717,128.671,96.666,128.672z M119.361,103.455
		c0.092-0.831,0.149-1.673,0.149-2.529c0-0.887-0.064-1.757-0.162-2.618c0.108-0.009,0.22-0.006,0.328-0.017
		c-0.1,0.866-0.165,1.742-0.165,2.634c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008
		C119.46,103.448,119.412,103.455,119.361,103.455z M142.056,128.672c0.092-0.831,0.149-1.673,0.149-2.529
		c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008S142.106,128.671,142.056,128.672z M164.751,103.455
		c0.092-0.831,0.149-1.673,0.149-2.529c0-0.887-0.064-1.757-0.162-2.618c0.108-0.009,0.22-0.006,0.328-0.017
		c-0.1,0.866-0.165,1.742-0.165,2.634c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008
		S164.802,103.455,164.751,103.455z M187.446,128.672c0.092-0.831,0.149-1.673,0.149-2.529c0-0.856-0.057-1.698-0.149-2.529
		c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529c0,0.856,0.057,1.698,0.149,2.529
		c-0.05,0-0.099-0.008-0.149-0.008S187.496,128.671,187.446,128.672z M210.141,103.455c0.092-0.831,0.149-1.673,0.149-2.529
		c0-0.887-0.064-1.757-0.162-2.618c0.108-0.009,0.22-0.006,0.328-0.017c-0.1,0.866-0.165,1.742-0.165,2.634
		c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008S210.191,103.455,210.141,103.455z M232.836,128.672
		c0.092-0.831,0.149-1.673,0.149-2.529c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008
		c-0.092,0.831-0.149,1.673-0.149,2.529c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008
		S232.886,128.671,232.836,128.672z"
          />
          <path
            id="XMLID_44_"
            style={{ fill: "#D77258" }}
            d="M34.376,159.361c2.49-22.257,21.497-39.711,44.39-39.711h0
		c22.893,0,41.9,17.454,44.39,39.711h0.285v4.964v59.567v130.569H53.947L34.092,164.325v-4.964H34.376z"
          />
          <path
            id="XMLID_501_"
            style={{ fill: "#DEDFE8" }}
            d="M209.291,159.361c-2.49-22.257-21.497-39.711-44.39-39.711h0
		c-22.893,0-41.9,17.454-44.39,39.711h-0.285v4.964v59.567v130.569h89.35V223.892v-59.567v-4.964H209.291z"
          />
          <path
            id="XMLID_502_"
            style={{ fill: "#FFE477" }}
            d="M278.375,128.664c-0.05,0-0.099,0.007-0.149,0.008
		c0.092-0.831,0.149-1.673,0.149-2.529c0-12.534-10.161-22.695-22.695-22.695c-0.05,0-0.099,0.007-0.149,0.008
		c0.092-0.831,0.149-1.673,0.149-2.529c0-12.534-10.161-22.695-22.695-22.695c-0.752,0-1.495,0.041-2.228,0.112
		c0.1-0.866,0.165-1.742,0.165-2.634c0-12.099-9.475-21.958-21.406-22.63C208.895,41.1,199.014,31.57,186.88,31.57
		c-10.615,0-19.505,7.294-21.98,17.14V98.3c0.055-0.002,0.111-0.003,0.165-0.008c-0.1,0.866-0.165,1.742-0.165,2.634
		c0,0.856,0.057,1.698,0.149,2.529c-0.05,0-0.099-0.008-0.149-0.008v45.39c0.05,0,0.099-0.007,0.149-0.008
		c-0.092,0.831-0.149,1.673-0.149,2.529c0,12.534,10.161,22.695,22.695,22.695c12.534,0,22.695-10.161,22.695-22.695
		c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,12.534,10.161,22.695,22.695,22.695s22.695-10.161,22.695-22.695c0-0.856-0.057-1.698-0.149-2.529
		c0.05,0,0.099,0.008,0.149,0.008c0.05,0,0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		c0,12.534,10.161,22.695,22.695,22.695c12.534,0,22.695-10.161,22.695-22.695C301.07,138.825,290.909,128.664,278.375,128.664z
		 M185.367,78.344c0.055-0.479,0.08-0.966,0.105-1.454c0.04,0.002,0.08,0.004,0.119,0.006c0.025,0.48,0.048,0.96,0.103,1.432
		C185.586,78.336,185.475,78.333,185.367,78.344z M187.744,128.672c-0.05,0-0.099-0.008-0.149-0.008s-0.099,0.007-0.149,0.008
		c0.092-0.831,0.149-1.673,0.149-2.529c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008
		c-0.092,0.831-0.149,1.673-0.149,2.529C187.595,126.999,187.652,127.84,187.744,128.672z M210.439,103.455
		c-0.05,0-0.099-0.008-0.149-0.008s-0.099,0.007-0.149,0.008c0.092-0.831,0.149-1.673,0.149-2.529c0-0.887-0.064-1.757-0.162-2.618
		c0.108-0.009,0.22-0.006,0.328-0.017c-0.1,0.866-0.165,1.742-0.165,2.634C210.29,101.782,210.347,102.624,210.439,103.455z
		 M233.134,128.672c-0.05,0-0.099-0.008-0.149-0.008s-0.099,0.007-0.149,0.008c0.092-0.831,0.149-1.673,0.149-2.529
		c0-0.856-0.057-1.698-0.149-2.529c0.05,0,0.099,0.008,0.149,0.008s0.099-0.007,0.149-0.008c-0.092,0.831-0.149,1.673-0.149,2.529
		C232.985,126.999,233.042,127.84,233.134,128.672z"
          />
          <path
            id="XMLID_510_"
            style={{ fill: "#C9C7D7" }}
            d="M209.291,159.361c-2.49-22.257-21.497-39.711-44.39-39.711h0v234.811h44.675
		V223.892v-59.567v-4.964H209.291z"
          />
          <path
            id="XMLID_515_"
            style={{ fill: "#D14F4E" }}
            d="M295.424,159.361c-2.49-22.257-21.497-39.711-44.39-39.711h0
		c-22.893,0-41.9,17.454-44.39,39.711h-0.285v4.964v59.567v130.569h69.495l19.856-190.136v-4.964H295.424z"
          />
        </svg>
      </div>
    </>
  );
};

export default Loading;
